import {
  CbPromoCodeKind,
  CbPromoCodeStatus,
  CbDiscountDuration,
  SubProductSubType,
  SubRecurringInterval,
} from 'api/graphql-global-types';

export const CB_PROMO_CODE_KIND_LABELS: Record<CbPromoCodeKind, string> = {
  [CbPromoCodeKind.CreditFree]: 'Free credit',
  [CbPromoCodeKind.CreditMatch]: 'Credit match',
  [CbPromoCodeKind.SubscriptionDiscount]: 'Subscription discount',
  [CbPromoCodeKind.SubscriptionTrial]: 'Free trial',
};

// Short helper copy shown under each type in the create form
export const CB_PROMO_CODE_KIND_DESCRIPTIONS: Record<CbPromoCodeKind, string> =
  {
    [CbPromoCodeKind.CreditFree]: 'Flat wallet credit on redemption',
    [CbPromoCodeKind.CreditMatch]: 'Bonus matched to a top-up',
    [CbPromoCodeKind.SubscriptionDiscount]: 'Percent off a plan',
    [CbPromoCodeKind.SubscriptionTrial]: 'Free days on a new plan',
  };

// antd Tag colors — keep status coloring consistent across the table
export const CB_PROMO_CODE_STATUS_COLORS: Record<CbPromoCodeStatus, string> = {
  [CbPromoCodeStatus.Active]: 'green',
  [CbPromoCodeStatus.Scheduled]: 'blue',
  [CbPromoCodeStatus.Paused]: 'orange',
  [CbPromoCodeStatus.Expired]: 'default',
  [CbPromoCodeStatus.Exhausted]: 'red',
};

export const CB_DISCOUNT_DURATION_LABELS: Record<CbDiscountDuration, string> = {
  [CbDiscountDuration.once]: 'Once',
  [CbDiscountDuration.repeating]: 'Repeating',
  [CbDiscountDuration.forever]: 'Forever',
};

export const SUB_PRODUCT_SUBTYPE_LABELS: Record<SubProductSubType, string> = {
  [SubProductSubType.free_plan]: 'Free plan',
  [SubProductSubType.full_plan]: 'Full plan',
  [SubProductSubType.pro_plan]: 'Pro plan',
  [SubProductSubType.team_plan]: 'Team plan',
  [SubProductSubType.team_seat]: 'Team seat',
  [SubProductSubType.plan_credit]: 'Plan credit',
};

export const SUB_RECURRING_INTERVAL_LABELS: Record<
  SubRecurringInterval,
  string
> = {
  [SubRecurringInterval.daily]: 'Daily',
  [SubRecurringInterval.weekly]: 'Weekly',
  [SubRecurringInterval.monthly]: 'Monthly',
  [SubRecurringInterval.every_3_months]: 'Every 3 months',
  [SubRecurringInterval.every_6_months]: 'Every 6 months',
  [SubRecurringInterval.yearly]: 'Yearly',
};

export const CB_PROMO_CODE_KIND_OPTIONS = Object.values(CbPromoCodeKind).map(
  (value) => ({ label: CB_PROMO_CODE_KIND_LABELS[value], value })
);

export const CB_DISCOUNT_DURATION_OPTIONS = Object.values(
  CbDiscountDuration
).map((value) => ({ label: CB_DISCOUNT_DURATION_LABELS[value], value }));

// Vanity code: 4–32 chars of A-Za-z0-9_-
export const CB_PROMO_CODE_REGEX = /^[A-Za-z0-9_-]{4,32}$/;
